// extracted by mini-css-extract-plugin
export default {"ratingButton":"ratingButton__TV9dOv","wiggleAnimation":"wiggleAnimation__Qxnr3q","wiggle":"wiggle__Ws210q"};